import React, { ChangeEvent, Fragment, FunctionComponent } from "react";

import { Caption, ColSpan, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { IAttrValue } from "@multiweb/types/contracts";
import { LOC_ACTION_FORM, LOC_BASIC_CONDITION, LOC_COMMENT, LOC_FORM, LOC_FORM_CONDITION, LOC_FORM_TYPE, LOC_OBJECT_BINDING, LOC_PRINT_FORM, LOC_REPORT, LOC_REPORT_NAME } from "../../../../../../locKeys";
import { FormType } from "../../../../../../workflowModel/Actions";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_OPEN_FORM_FORM_CLASS_AT, CONST_OPEN_FORM_FORM_CONDITION_AT, CONST_OPEN_FORM_FORM_TYPE_AT, CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT, CONST_OPEN_FORM_REPORT_NAME_AT } from "../../../../../../workflowParser/constants";
import { Edit, Memo, TextLOVEdit, WfOption, WfSelect } from "../../../../components";
import { MAX_INPUT_LENGTH_L } from "../constants";
import { ActionPageProps } from "../types";

const getFormClassAttrs = ["Kod_formulare"];

export const OpenFormPage: FunctionComponent<ActionPageProps> = ({ hostKey, properties, updateAction }) => {
    const formType = properties[CONST_OPEN_FORM_FORM_TYPE_AT];
    const isReportType = formType === FormType.report;

    const getFormClass = (results: readonly IAttrValue[] | undefined) => {
        if (results) {
            const newName = results[0].toString(); // Je potřeba opravit na straně akce openFormModal, tady se dostane objekt, na kterém se musí zavolat .toString()
            updateAction([{ key: CONST_OPEN_FORM_FORM_CLASS_AT, value: newName }]);
        }
    };

    const onFormTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
        updateAction([{ key: CONST_OPEN_FORM_FORM_TYPE_AT, value: e.target.value }]);
    };

    const onFormClassChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_OPEN_FORM_FORM_CLASS_AT, value: e.target.value }]);
    };

    const onReportNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_OPEN_FORM_REPORT_NAME_AT, value: e.target.value }]);
    };

    const onMasterLinkToAttrChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT, value: e.target.value }]);
    };

    const onFormConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_OPEN_FORM_FORM_CONDITION_AT, value: e.target.value }]);
    };

    const onConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_CONDITION_AT, value: e.target.value }]);
    };

    const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_COMMENT_AT, value: e.target.value }]);
    };

    return (
        <GridLayout columns={GridColumnCount.five} gap={GridGapSize.two}>
            <GridLayoutItem colSpan={ColSpan.two}>
                <Caption locKey={LOC_FORM_TYPE} />
                <WfSelect qa={LOC_FORM_TYPE} value={properties[CONST_OPEN_FORM_FORM_TYPE_AT]} onChange={onFormTypeChange} {...{ hostKey }}>
                    <WfOption qa={FormType.report} value={FormType.report} locKey={LOC_REPORT} />
                    <WfOption qa={FormType.form} value={FormType.form} locKey={LOC_FORM} />
                    <WfOption qa={FormType.printForm} value={FormType.printForm} locKey={LOC_PRINT_FORM} />
                    <WfOption qa={FormType.actionForm} value={FormType.actionForm} locKey={LOC_ACTION_FORM} />
                </WfSelect>
            </GridLayoutItem>
            {isReportType &&
                <GridLayoutItem colSpan={ColSpan.three}>
                    <Caption required locKey={LOC_REPORT_NAME} />
                    <Edit qa={LOC_REPORT_NAME} required maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_OPEN_FORM_REPORT_NAME_AT]} onChange={onReportNameChange} {...{ hostKey }} />
                </GridLayoutItem>}
            {!isReportType &&
                <Fragment>
                    <GridLayoutItem colSpan={ColSpan.three}>
                        <Caption required locKey={LOC_FORM} />
                        <TextLOVEdit
                            qa={LOC_FORM}
                            required
                            value={properties[CONST_OPEN_FORM_FORM_CLASS_AT]}
                            formName={"FRM.CFormular.CFormular"}
                            attributeNames={getFormClassAttrs}
                            maxLength={MAX_INPUT_LENGTH_L}
                            onChange={onFormClassChange}
                            onFormClose={getFormClass}
                            {...{ hostKey }} />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={ColSpan.five}>
                        <Caption locKey={LOC_OBJECT_BINDING} />
                        <Edit qa={LOC_OBJECT_BINDING} maxLength={MAX_INPUT_LENGTH_L} value={properties[CONST_OPEN_FORM_MASTER_LINK_TO_ATTR_AT]} onChange={onMasterLinkToAttrChange} {...{ hostKey }} />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={ColSpan.five}>
                        <Caption locKey={LOC_FORM_CONDITION} />
                        <Memo qa={LOC_FORM_CONDITION} value={properties[CONST_OPEN_FORM_FORM_CONDITION_AT]} onChange={onFormConditionChange} {...{ hostKey }} />
                    </GridLayoutItem>
                </Fragment>}
            <GridLayoutItem colSpan={ColSpan.five}>
                <Caption locKey={LOC_BASIC_CONDITION} />
                <Memo qa={LOC_BASIC_CONDITION} value={properties[CONST_ACTION_CONDITION_AT]} onChange={onConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.five}>
                <Caption locKey={LOC_COMMENT} />
                <Memo qa={LOC_COMMENT} value={properties[CONST_ACTION_COMMENT_AT]} onChange={onCommentChange} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
